import api from './api'

const customerService = {
  async getAll() {
    const response = await api.get('/customers')
    return response.data
  },

  async getById(id) {
    const response = await api.get(`/customers/${id}`)
    return response.data
  },

  async create(customerData) {
    const response = await api.post('/customers', customerData)
    return response.data
  },

  async update(id, customerData) {
    const response = await api.put(`/customers/${id}`, customerData)
    return response.data
  },

  async delete(id) {
    const response = await api.delete(`/customers/${id}`)
    return response.data
  },

  async searchSOSCustomers(query = '') {
    const response = await api.get('/customers/search-sos-customers', {
      params: { q: query }
    })
    return response.data
  },

  async getSOSCustomerById(sosCustomerId) {
    const response = await api.get(`/customers/sos-customer/${sosCustomerId}`)
    return response.data
  }
}

export default customerService
